import { render, staticRenderFns } from "./classical-validation-score-detail.vue?vue&type=template&id=eb21b690"
import script from "./classical-validation-score-detail.vue?vue&type=script&lang=js"
export * from "./classical-validation-score-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports